<article>
  <header
    [ngClass]="{
      'menu-collapse': isMenuCollapsed,
      'menu-expand': !isMenuCollapsed
    }"
  >
    <button
      aria-controls="vertical-navigation-menu"
      aria-label="Open and close menu button"
      motif-header-menu
      id="header-btn"
      (click)="menuToggleHandler()"
      [attr.aria-expanded]="!isMenuCollapsed"
    ></button>
    <div class="header-left">
      <a routerLink="/" aria-label="Home Page">
        <img src="./assets/images/ey-logo-inverted.svg" alt="EY Logo" />
      </a>
      <!-- <label *ngIf="isMenuCollapsed">MS World Experience</label> -->
    </div>
    <div class="header-main">
      <div class="logoWrapper">
        <div class="logo">
          <label class="main-header">MS Control Tower</label>
          <p class="sub-header">Manage services experience</p>
        </div>
        <!-- <span><img src="./assets/images/lending-club.jpg" alt="" /></span> -->
      </div>

      <div class="header-right">
        <div class="personaRadio">
          <input
            type="radio"
            id="radio-one"
            name="switch-one"
            value="GCSP"
            [(ngModel)]="persona"
            (change)="onPersonaChange('GCSP')"
            [checked]="persona === 'GCSP'"
          />
          <label for="radio-one">GCSP</label>

          <input
            type="radio"
            id="radio-two"
            name="switch-one"
            value="Client"
            [(ngModel)]="persona"
            (change)="onPersonaChange('Client')"
            [checked]="persona === 'Client'"
          />
          <label for="radio-two">Client</label>
        </div>
        <div class="lendingLogo" *ngIf="engagementId && clientName">
          <img
            [src]="
              clientName === 'Generic Client' || clientName === 'Quantum Leap'
                ? 'assets/images/' + formatClientName(clientName) + '-logo.svg'
                : 'assets/images/' + formatClientName(clientName) + '.png'
            "
            alt=""
          />
        </div>
        <div class="userInfo">
          <motif-avatar
            size="medium"
            [userName]="userDetails.displayName"
            [src]="userDetails.base64ProfileImage"
          ></motif-avatar>
          <span>{{ userDetails.displayName }}</span>
        </div>
      </div>
    </div>
  </header>
</article>
